module.exports = __webpack_public_path__ + "img/unavailable.dbedc6cc.png";